/* eslint-disable */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import VueCookies from "vue-cookies";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';

loadFonts();

const app = createApp(App);
app.component('VueDatePicker', VueDatePicker);

app.use(router);
app.use(store);
app.use(vuetify);
app.use(VueCookies, {
  expires: "90min",
  path: "/",
});

app.mount("#app");
